import React from "react";
import Contracts from "../../Contracts";
import CardSection from "../../../../components/ui/card/CardSection";
import RenderTabs2 from "../../../../components/ui/tabs/RenderTabs2";
import CreateInvoices from "./features/createInvoices/CreateInvoices";
import PriorInvoices from "./features/priorInvoices/PriorInvoices";
import ContractWithoutSchedule from "./features/contractWithoutSchedule/ContractWithoutSchedule";

const Invoices = () => {
  const tabs = [
    {
      sMenuItemCaption: "Create Invoices",
      component: <CreateInvoices />,
      isDynamic: false,
    },
    {
      sMenuItemCaption: "Prior Invoices",
      component: <PriorInvoices />,
      isDynamic: false,
    },
    {
      sMenuItemCaption: "Contract Without Schedule",
      component: <ContractWithoutSchedule />,
      isDynamic: false,
    },
  ];
  return (
    <>
      <div className="invoices-section">
        {/* <CardSection cardTitle="Contract Invoices" customHeader={true}> */}
        <div className="tab-section-button">
          <RenderTabs2 tabs={tabs} />
        </div>
        {/* </CardSection> */}
      </div>
    </>
  );
};

export default Contracts(Invoices);
